module.exports = __webpack_public_path__ + "static/media/diy overszied mat frames.01849167.JPG";